<tsl-form-field class="w-100">
    <tsl-label i18n>{{translate.get(labelText)}}</tsl-label>
    <input [tslAutocomplete]="auto" tslInput [placeholder]="translate.get(inputPlaceholder)" [formControl]="formControl" autocomplete="off" (click)="onClick()" />
    <tsl-autocomplete #auto="tslAutocomplete" (optionSelected)="onSelection($event.option)" panelClass="select-autocomplete-panel">
        <tsl-option *ngFor="let option of filteredvalue$ | async" [value]="valueSelector(option)">
            {{textSelector(option)}}
        </tsl-option>
    </tsl-autocomplete>
    <tsl-error
        *ngIf="formControl.errors &&  (formControl.dirty ||  formControl.touched)">
        <span>{{translate.get(errorMessage)}}</span>
    </tsl-error>
</tsl-form-field>